import { FC, useContext, useEffect, useMemo } from "react";
import { useProperty } from "@services";
import PropertiesList from "./PropertiesList";
import { useTranslation } from "react-i18next";
import AirbnbIcon from "@assets/svg/airbnb-icon.svg?react";
import { useIsMutating } from "@tanstack/react-query";
import { ToastMessageContext } from "@context/toast-message-cotnext";
import { Property } from "src/services/useCategoryMangment/types";

const AirBnbProperties: FC<{
  reset: (close: boolean) => void;
  channelId: string;
  parentProperty: Property;
  onNext: () => void;
}> = ({ reset, channelId, onNext, parentProperty }) => {
  const {
    getAirbnbListingQuery,
    addPropertyMutate,
    connectToNewChannelMutate,
  } = useProperty();

  const { t } = useTranslation();
  const {
    data,
    isLoading,
    isError: errorFetching,
  } = getAirbnbListingQuery(channelId);
  const mutating = useIsMutating();
  const { mutate: addProperty, isError, isSuccess } = addPropertyMutate({});
  const { showError } = useContext(ToastMessageContext);

  const { mutate: connectNewChannelMutaion, isPending: isConnecting } =
    connectToNewChannelMutate({
      onSuccess: () => {
        onNext();
      },
      onError: () => {
        showError(t("ERRORS.SOMETHING_WENT_WRONG"));
      },
    });

  const onLink = (properties: any[]) => {
    properties?.map((property) => {
      let ob = {
        propertyId: parentProperty?.propertyId,
        gathrenUnitId: "",
        airbnbUnitId: property?.id,
        propertyName: parentProperty?.propertyName,
        booking: null,
        chaletId: 0,
      };
      connectNewChannelMutaion(ob);
    });
  };
  const list = useMemo(() => {
    return data?.response?.data?.listing_id_dictionary?.values ?? [];
  }, [data]);
  return (
    <>
      <PropertiesList
        loading={isLoading}
        channel={t("AIRBNB")}
        mutate={onLink}
        channelIcon={<AirbnbIcon />}
        propertyList={list}
        success={isSuccess}
        error={isError || errorFetching}
        reset={reset}
        mutating={mutating > 0}
        onNext={onNext}
      />
    </>
  );
};
export default AirBnbProperties;
